import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/neoscriber/publish/src/components/common/pages/page-component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/neoscriber/publish/src/components/journal-site/_partials/header/journal-header.tsx");
